import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { Copy } from '../../../../../shared/Assets/svgIcons';
import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { copyProgram } from '../../../../../redux/State/clientSlice/clientProgramSlice';
import { ProgramProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { useProgramsContext } from '../ProgramsContext';

const CopyProgram = ({ data, onlyIcon }: { data: ProgramProperties; onlyIcon?: boolean }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { fetchData } = useProgramsContext();

	const skillAreaId = useSelector((state) => state.skillArea.skillAreaId);

	const [copyConfirm, setCopyConfirm] = useState<boolean>(false);

	const copyProgramHandler = () => {
		dispatch(copyProgram(data))
			.then(unwrapResult)
			.then(() => {
				if (!skillAreaId) {
					setCopyConfirm(false);

					return;
				}
				fetchData();
				setCopyConfirm(false);
			});
	};

	return (
		<>
			<div className="actionRow" onClick={() => setCopyConfirm(true)}>
				<div className="actionIcon">
					<Copy />
				</div>
				{!onlyIcon && (
					<div className="actionContent">
						<Text title="Copy" type="psm" fontWeight="medium" />
					</div>
				)}
			</div>
			<CustomAlert
				open={copyConfirm}
				onClose={() => setCopyConfirm(false)}
				title="Do you want to copy?"
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Yes" onClick={copyProgramHandler} />
						<CustomButton title="No" buttonType="secondaryGray" onClick={() => setCopyConfirm(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default CopyProgram;
